import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import MyProxies from "./MyProxies";
import MySubjects from "./MySubjects";
import ErrorMsg from "./home/ErrorMsg";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";
import Spinner from "../common/spinner";
import { EPIC, RX } from "../../constants/textConstants";
import { ContentSwitcher, Typography } from "../ecosystem";

class ProxySetup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            proxyAccess: 'Grant Access'

        }
        this.acessOptions = ['Grant Access', 'Request Access'];
    }

    componentDidMount() {
        const { proxySource, userId, getRequestProxyInfo } = this.props;
        getRequestProxyInfo(proxySource, userId); //request list        
        logUI("MBHWeb.UI.ProxySetup.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { epicManagerList, epicSubjectList, requestProxyInfo, isBothSource,
            proxySource, actionType, epicManagerFailure, epicSubjectFailure, age, enableProxyRequestV2, isMobile, currentMyChartUser, removeBSWPharmacy } = this.props;
      
        const isAdult = age && age > 17 ? true : false;
        let requestPharmacyInfo = [];
        let requestMedicalRecordsInfo = [];
        let isMinor =  currentMyChartUser && currentMyChartUser.ageYears && currentMyChartUser.ageYears >= 14 && currentMyChartUser.ageYears <= 16 ? true : false;
        //grant
        let grantPharmacyInfo = [];
        let grantMedicalRecordsInfo = [];

       

        if (isBothSource) {
            if (requestProxyInfo && requestProxyInfo.response) {
                //request pharmacy
                requestPharmacyInfo.WhoCanManageYou = requestProxyInfo.response.PharmacyProxyInformation && requestProxyInfo.response.PharmacyProxyInformation.WhoCanManageYou && requestProxyInfo.response.PharmacyProxyInformation.WhoCanManageYou.filter(account => (account.RequestType.toLowerCase() === 'request'));
                requestPharmacyInfo.WhoYouCanManage = requestProxyInfo.response.PharmacyProxyInformation && requestProxyInfo.response.PharmacyProxyInformation.WhoYouCanManage && requestProxyInfo.response.PharmacyProxyInformation.WhoYouCanManage.filter(account => (account.RequestType.toLowerCase() === 'request'));
                //request medical
                requestMedicalRecordsInfo.WhoCanManageYou = requestProxyInfo.response.EpicProxyInformation && requestProxyInfo.response.EpicProxyInformation.WhoCanManageYou && requestProxyInfo.response.EpicProxyInformation.WhoCanManageYou.filter(account => enableProxyRequestV2 && account.RequestType.toLowerCase() === 'request.v2');
                requestMedicalRecordsInfo.WhoYouCanManage = requestProxyInfo.response.EpicProxyInformation && requestProxyInfo.response.EpicProxyInformation.WhoYouCanManage && requestProxyInfo.response.EpicProxyInformation.WhoYouCanManage.filter(account => enableProxyRequestV2 && account.RequestType.toLowerCase() === 'request.v2');

                //grant Pharmacy
                grantPharmacyInfo.WhoCanManageYou = requestProxyInfo.response.PharmacyProxyInformation && requestProxyInfo.response.PharmacyProxyInformation.WhoCanManageYou && requestProxyInfo.response.PharmacyProxyInformation.WhoCanManageYou.filter(account => account.RequestType.toLowerCase() === 'grant');
                grantPharmacyInfo.WhoYouCanManage = requestProxyInfo.response.PharmacyProxyInformation && requestProxyInfo.response.PharmacyProxyInformation.WhoYouCanManage && requestProxyInfo.response.PharmacyProxyInformation.WhoYouCanManage.filter(account => account.RequestType.toLowerCase() === 'grant');
                //grant Medical records
                grantMedicalRecordsInfo.WhoCanManageYou = requestProxyInfo.response.EpicProxyInformation && requestProxyInfo.response.EpicProxyInformation.WhoCanManageYou && requestProxyInfo.response.EpicProxyInformation.WhoCanManageYou.filter(account => account.RequestType.toLowerCase() === 'grant');
                grantMedicalRecordsInfo.WhoYouCanManage = requestProxyInfo.response.EpicProxyInformation && requestProxyInfo.response.EpicProxyInformation.WhoYouCanManage && requestProxyInfo.response.EpicProxyInformation.WhoYouCanManage.filter(account => account.RequestType.toLowerCase() === 'grant');
            }
        }
        if (proxySource.toLowerCase() === RX) {
            requestPharmacyInfo.WhoCanManageYou = requestProxyInfo && requestProxyInfo.response && requestProxyInfo.response.WhoCanManageYou && requestProxyInfo.response.WhoCanManageYou.filter(account => (account.RequestType.toLowerCase() === 'request'));
            requestPharmacyInfo.WhoYouCanManage = requestProxyInfo && requestProxyInfo.response && requestProxyInfo.response.WhoYouCanManage && requestProxyInfo.response.WhoYouCanManage.filter(account => (account.RequestType.toLowerCase() === 'request'));

            //grant Pharmacy
            grantPharmacyInfo.WhoCanManageYou = requestProxyInfo && requestProxyInfo.response && requestProxyInfo.response.WhoCanManageYou && requestProxyInfo.response.WhoCanManageYou.filter(account => account.RequestType.toLowerCase() === 'grant');
            grantPharmacyInfo.WhoYouCanManage = requestProxyInfo && requestProxyInfo.response && requestProxyInfo.response.WhoYouCanManage && requestProxyInfo.response.WhoYouCanManage.filter(account => account.RequestType.toLowerCase() === 'grant');
        }
        if (proxySource.toLowerCase() === EPIC) {
            //request medical
            requestMedicalRecordsInfo.WhoCanManageYou = requestProxyInfo.response.EpicProxyInformation && requestProxyInfo.response.EpicProxyInformation.WhoCanManageYou && requestProxyInfo.response.EpicProxyInformation.WhoCanManageYou.filter(account => enableProxyRequestV2 && account.RequestType.toLowerCase() === 'request.v2');
            requestMedicalRecordsInfo.WhoYouCanManage = requestProxyInfo.response.EpicProxyInformation && requestProxyInfo.response.EpicProxyInformation.WhoYouCanManage && requestProxyInfo.response.EpicProxyInformation.WhoYouCanManage.filter(account => enableProxyRequestV2 && account.RequestType.toLowerCase() === 'request.v2');

            //grant MedicalRecords
            grantMedicalRecordsInfo.WhoCanManageYou = requestProxyInfo && requestProxyInfo.response && requestProxyInfo.response.WhoCanManageYou && requestProxyInfo.response.WhoCanManageYou.filter(account => account.RequestType.toLowerCase() === 'grant');
            grantMedicalRecordsInfo.WhoYouCanManage = requestProxyInfo && requestProxyInfo.response && requestProxyInfo.response.WhoYouCanManage && requestProxyInfo.response.WhoYouCanManage.filter(account => account.RequestType.toLowerCase() === 'grant');
        }
        return (
            <React.Fragment>
                {(typeof requestProxyInfo !== 'undefined')
                    ? (requestProxyInfo.success || !epicSubjectFailure || !epicManagerFailure)
                        ? <div className="row">
                            <div className="col-12">
                                {isMobile && isAdult &&
                                    <div className="proxy-access-switcher">
                                        <ContentSwitcher
                                            options={this.acessOptions}
                                            onChange={(e) => { this.setState({ proxyAccess: e }) }}
                                            defaultIndex={this.acessOptions.indexOf(this.state.proxyAccess)}
                                        />
                                    </div>
                                }
                                <div className="row proxy-home-intro">
                                    {(this.state.proxyAccess === 'Grant Access' || !isMobile) &&
                                        <div className="col-12 col-xl">

                                            {removeBSWPharmacy ?

                                               ( isMobile && <Typography type="body-02" tag="p">
                                                    Give access to a family member to view your appointments,  medical records, and prescriptions.
                                                </Typography>)
                                                :
                                               ( isMobile && <Typography type="body-02" tag="p">
                                                    Give access to a family member to view your appointments and medical records.
                                                </Typography>)
                                            }
                                           
                                            

                                           
                                            <Typography type="heading-03" tag="p">Current managers of your account</Typography>

                                            {removeBSWPharmacy ?
                                            (!isMobile && <Typography type="body-02" tag="p">
                                                Give access to a family member to view your appointments,  medical records, and prescriptions.
                                            </Typography>)
                                            :
                                            (!isMobile && <Typography type="body-02" tag="p">
                                                Give access to a family member to view your appointments and medical records.
                                            </Typography>)
                                            }
                                        </div>
                                    }

                                    {isAdult && ((removeBSWPharmacy && !isMinor) || !removeBSWPharmacy) && (this.state.proxyAccess === 'Request Access' || !isMobile) &&
                                        <div className="col-12 col-xl">

                                            {removeBSWPharmacy ?
                                            (isMobile && <Typography type="body-02" tag="p">
                                                Request access to appointments, medical records, and prescriptions. Verification documentation may be required.
                                            </Typography>)
                                            :
                                            (isMobile && <Typography type="body-02" tag="p">
                                                Request access to appointments and records. Verification documentation may be required.
                                            </Typography>)
                                            }

                                        
                                            <Typography type="heading-03" tag="p">Accounts you currently manage</Typography>

                                            {removeBSWPharmacy ?
                                            (!isMobile && <Typography type="body-02" tag="p" >
                                                Request access to appointments, medical records, and prescriptions. Verification documentation may be required.
                                            </Typography>)
                                            :
                                            (!isMobile && <Typography type="body-02" tag="p" >
                                                Request access to appointments and records. Verification documentation may be required.
                                            </Typography>)
                                            }
                                        </div>
                                    }
                                </div>
                                <div className="row proxy-accounts">
                                    {(this.state.proxyAccess === 'Grant Access' || !isMobile) && <div className="col-12 col-xl-6">
                                        <MyProxies
                                            list={requestPharmacyInfo && requestPharmacyInfo.WhoCanManageYou ? requestPharmacyInfo.WhoCanManageYou : []}
                                            grantPharmacyList={grantPharmacyInfo && grantPharmacyInfo.WhoCanManageYou ? grantPharmacyInfo.WhoCanManageYou : []}
                                            grantEpicList={grantMedicalRecordsInfo && grantMedicalRecordsInfo.WhoCanManageYou ? grantMedicalRecordsInfo.WhoCanManageYou : []}
                                            epicManagerList={epicManagerList}
                                            actionType={actionType}
                                            epicManagerFailure={epicManagerFailure}
                                            pharmacyError={requestProxyInfo.error}
                                            requestEpicList={requestMedicalRecordsInfo && requestMedicalRecordsInfo.WhoCanManageYou ? requestMedicalRecordsInfo.WhoCanManageYou : []}
                                        />
                                    </div>}
                                    {isAdult && ((removeBSWPharmacy && !isMinor) || !removeBSWPharmacy)&&// show subjectlist (accounts you currently manage) to adults only
                                        (this.state.proxyAccess === 'Request Access' || !isMobile)  && (<div className="col-12 col-xl-6">
                                            <MySubjects
                                                referrer={this.props.referrer}
                                                actionType={actionType}
                                                pharmacyList={requestPharmacyInfo && requestPharmacyInfo.WhoYouCanManage ? requestPharmacyInfo.WhoYouCanManage : []}
                                                grantPharmacyList={grantPharmacyInfo && grantPharmacyInfo.WhoYouCanManage ? grantPharmacyInfo.WhoYouCanManage : []}
                                                grantEpicList={grantMedicalRecordsInfo && grantMedicalRecordsInfo.WhoYouCanManage ? grantMedicalRecordsInfo.WhoYouCanManage : []}
                                                epicSubjectList={epicSubjectList}
                                                epicSubjectFailure={epicSubjectFailure}
                                                pharmacyError={requestProxyInfo.error}
                                                requestEpicList={requestMedicalRecordsInfo && requestMedicalRecordsInfo.WhoYouCanManage ? requestMedicalRecordsInfo.WhoYouCanManage : []}

                                            />
                                        </div>)
                                    }
                                </div>
                            </div>
                        </div>
                        : requestProxyInfo.success === false && requestProxyInfo.waiting === false
                            ? <ErrorMsg message="Sorry, we're not able to display your family pharmacy/medical record accounts. Please try again later." />
                            : null : null
                }
                {(typeof requestProxyInfo === 'undefined' || requestProxyInfo.waiting) &&
                    <>
                        <div className="row overlay-loading-container">
                            <div className="col-12 align-self-center">
                                <Spinner />
                            </div>
                        </div>
                    </>
                }
            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    let pl = [], cm = [];

    //let showAccessAndProxiesList = state.session.serverData && state.session.serverData.ShowAccessAndProxiesList;
    let showGrantProxyAccess = state.session.serverData && state.session.serverData.showGrantProxyAccess;
    if (!showGrantProxyAccess) { //load epic list only if this config is disbabled else show proxyInfo list.
        if (state.domain.pl) {
            state.domain.pl.forEach((c, index, arr) => {
                pl.push(d.hydrateProxyUser(c));
            });
        }

        if (pl.length > 0) {
            pl.shift(); // remove the logged-in user from the list
        }

        if (state.domain.cm) {
            state.domain.cm.forEach((c, index, arr) => {
                cm.push(d.hydrateProxyUser(c));
            });
        }
    }
    let proxySource = 'Rx';
    let isProxySourceBoth = false;
    if (state.domain.hm) {
        proxySource = "Rx,Epic";
        isProxySourceBoth = true;
    }
    /*else if (hasMyChartLogin) {
        proxySource = "Epic";
    }
    else if (hasPharmacyLogin) {
        proxySource = "Rx";
    }*/

    return {
        requestProxyInfo: state.common[types.REQUEST_PROXY_INFO],
        //account data        
        proxySource,
        isBothSource: isProxySourceBoth,
        userId: state.domain.un,
        age: state.domain.age,
        epicSubjectList: pl,
        epicManagerList: cm,
        epicSubjectFailure: state.memberships.proxyListFailure,
        epicManagerFailure: state.domain.managerListFailure,
        actionType: state.common.actionType,
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false,

       
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        hasMyChart: state.domain.hm,

        showGrantProxyAccess: state.session.serverData ? state.session.serverData.showGrantProxyAccess : false,
        enableProxyRequestV2: state.session.serverData ? state.session.serverData.enableProxyRequestV2 : false
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRequestProxyInfo: (proxySource, userId) => dispatch({ type: types.REQUEST_PROXY_INFO, data: { userId, proxySource } })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProxySetup);